/** @format */

const ourStoryDustLogs = {
  // ourStory 页曝光
  ourStoryPageShowLog: {
    event: 'page_show',
    params: {
      page: 'ourStory',
    },
  },
};

export default ourStoryDustLogs;
